// src/utils/echo.js
import Echo from "laravel-echo";
import Pusher from "pusher-js";
import { getCustomerToken } from "./CustomerAuth";

window.Pusher = Pusher;

const createEcho = () => {
  const token = getCustomerToken();

  const authHeaders = {
    Authorization: token ? `Bearer ${token}` : "",
    Accept: "application/json",
  };

  const apiUrl = process.env.REACT_APP_API_URL || "https://api.ifjona.com/api";

  return new Echo({
    broadcaster: "reverb",
    key: process.env.REACT_APP_REVERB_APP_KEY,

    wsHost: process.env.REACT_APP_REVERB_HOST,
    wsPort: Number(process.env.REACT_APP_REVERB_PORT || 80),
    wssPort: Number(process.env.REACT_APP_REVERB_PORT || 443),

    forceTLS: process.env.REACT_APP_REVERB_SCHEME === "https",
    enabledTransports: ["ws", "wss"],

    authEndpoint: `${apiUrl}/broadcasting/auth`,

    auth: {
      headers: authHeaders,
    },

    channelAuthorization: {
      endpoint: `${apiUrl}/broadcasting/auth`,
      transport: "ajax",
      headers: authHeaders,
    },
  });
};

export default createEcho;
